import React from 'react';
import {observer} from 'mobx-react';
import {Box} from '@mui/material';
import FormSection from '../../../forms/FormSection';
import FormRow from '../../../forms/FormRow';
import FormColumn from '../../../forms/FormColumn';
import FormTextField from '../../../components/fields/FormTextField';
import FormAutocompleteMultipleSelectField from '../../../components/fields/FormAutocompleteMultipleSelectField';
import CompletionProgressBar from '../../../components/CompletionProgressBar';
import FormSkeleton from '../../../components/FormSkeleton';
import useFeature from '../../../useFeature';
import CuitFormatter from "../../../utils/CuitRenderer";

function LegalEntityPanel({ generalFeature }) {
    const feature = useFeature(() => generalFeature.features['LegalEntityPanelFeature'])
    const isFeatureReady = (feature) => {
        return feature && feature.loaded;
    }

    if (!isFeatureReady(feature)) {
        return (
            <FormSkeleton
                rows={3} 
                fieldsPerRow={3} 
            />
        );
    }

    const form = feature.form;
    return (<Box p={3} display="flex" flexDirection="column" gap={3}>
            <CompletionProgressBar form={form} />
            <FormSection title="Datos del Cliente">
                <FormColumn>
                    <FormRow>
                        <FormTextField
                            label="CUIT"
                            disabled={true}
                            form={form}
                            fieldName={"taxpayerIdentificationNumber"}
                            formatter={new CuitFormatter()}
                        />
                        <FormTextField
                            label="Razón Social"
                            form={form}
                            fieldName={"businessName"}
                        />
                        <FormTextField
                            label="Nombre de Fantasía"
                            form={form}
                            fieldName={"fantasyName"}
                        />
                    </FormRow>

                    <FormRow>
                        <FormTextField
                            label="Domicilio Fiscal"
                            form={form}
                            fieldName={"fiscalAddress"}
                        />
                        <FormTextField
                            label="Localidad"
                            form={form}
                            fieldName={"city"}
                        />
                        <FormTextField
                            label="Código Postal"
                            form={form}
                            fieldName={"postalCode"}
                        />
                    </FormRow>

                    <FormRow>
                        <FormAutocompleteMultipleSelectField
                            label="Jurisdicciones"
                            form={form}
                            fieldName={"jurisdictions"}
                            options={feature.jurisdictionsOptions()}
                        />
                    </FormRow>
                </FormColumn>
            </FormSection>
        </Box>

    );
}

export default observer(LegalEntityPanel);
